import React from 'react'
import { Dropdown } from 'tea-component'

import Result from './components/Result'
import Selector from './components/Selector'
import useSelector from './hooks/useSelector'
import useResult from './hooks/useResult'
import './index.scss'
import { Props } from './types'

const RangeDayMonthSelector = (props: Props) => {
  const {
    value,
    defaultValue,
    onConfirm,
    onCancel,
    disabled = false,
    alignedBy,
  } = props
  const {
    result,
    handleCancel,
    handleConfirm
  } = useResult({
    value,
    defaultValue,
    onConfirm,
    onCancel,
  })

  return (
    <Dropdown
      clickClose={false}
      style={{ marginRight: 10 }}
      button={<Result value={result} alignedBy={alignedBy} />}
      disabled={disabled}
      className={`range-day-month-selector__header-wrapper`}
      boxStyle={{
        padding: 0
      }}
    >
      {(
        close => (
          <Selector
            defaultValue={result}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            close={close}
            alignedBy={alignedBy}
          />
        ))
      }
      
    </Dropdown>
  )
}

export default RangeDayMonthSelector